export default __webpack_public_path__ + "static/about-ekko-bg-tablet-fbb5779c68b20bca5798b67396fec4ac.jpg";